import type {ColorBackground} from '@PosterWhiteboard/page/background/color-background.class';
import type {ImageBackground} from '@PosterWhiteboard/page/background/image-background.class';
import type {VideoBackground} from '@PosterWhiteboard/page/background/video-background.class';

export enum BackgroundTypeName {
  COLOR = 'color',
  IMAGE = 'image',
  VIDEO = 'video',
}

export interface BaseBackgroundObject {
  type: BackgroundTypeName;
}

export type BackgroundType = ColorBackground | ImageBackground | VideoBackground;

export function isColorBackground(bg: BackgroundType): bg is ColorBackground {
  return bg.type === BackgroundTypeName.COLOR;
}

export function isImageBackground(bg: BackgroundType): bg is ImageBackground {
  return bg.type === BackgroundTypeName.IMAGE;
}

export function isVideoBackground(bg: BackgroundType): bg is VideoBackground {
  return bg.type === BackgroundTypeName.VIDEO;
}
